import { Box, Stack, Text } from '@atlaskit/primitives';
import type { ColumnDef } from '@tanstack/react-table';
import DataTable from '@shared/ui/DataTable';
import type {
  DemandPartnerProfile,
  SupplyPartnerProfile
} from '@features/partnerManagement/data';

type PartnerRow = SupplyPartnerProfile | DemandPartnerProfile;

interface PartnerListTableProps<TPartner extends PartnerRow> {
  items: TPartner[];
  columns: ColumnDef<TPartner, unknown>[];
  emptyMessage?: string;
}

export default function PartnerListTable<TPartner extends PartnerRow>({
  items,
  columns,
  emptyMessage = 'No partners found'
}: PartnerListTableProps<TPartner>) {
  return (
    <Stack space="space.200">
      <Box
        style={{
          alignItems: 'center',
          display: 'flex',
          justifyContent: 'space-between'
        }}
      >
        <Text color="color.text.subtlest" size="small">
          Showing {items.length} partner profiles
        </Text>
      </Box>
      <DataTable
        data={items}
        columns={columns}
        emptyMessage={emptyMessage}
        maxHeight="60vh"
      />
    </Stack>
  );
}
